export const FETCH_QUERY_OBLIGATIONS_REQUEST = "OBLIGATIONS/FETCH_QUERY_REQUEST";
export const FETCH_QUERY_OBLIGATIONS_SUCCESS = "OBLIGATIONS/FETCH_QUERY_SUCCESS";
export const FETCH_QUERY_OBLIGATIONS_FAILURE = "OBLIGATIONS/FETCH_QUERY_FAILURE";

export const FETCH_QUERY_OBLIGATION_REQUEST = "OBLIGATION/FETCH_QUERY_REQUEST";
export const FETCH_QUERY_OBLIGATION_SUCCESS = "OBLIGATION/FETCH_QUERY_SUCCESS";
export const FETCH_QUERY_OBLIGATION_FAILURE = "OBLIGATION/FETCH_QUERY_FAILURE";
